






































import { Vue, Component, Prop } from 'vue-property-decorator';
import { AdType, AdSet, CouponAdConf } from '@/types/we-coupons';
import { language, windowHelper, CustomException } from '@tencent/ppd-base-libs';
import ShareCouponAd from './share-coupon-ad.vue';
import PictureAd from './picture-ad.vue';
import Swiper from 'swiper';
import SwiperPagination from '@/components/v3/common/swiper-pagination.vue';
import { biClick } from '@tencent/fit-bi-sdk';
import { getMerchantInfo } from '@/business/we-coupons/ad';
import { to } from '@tencent/wphk-base-utils';

enum AdName {
  'PictureAd' = 'PictureAd',
  'ShareCouponAd' = 'ShareCouponAd',
}

@Component({
  components: {
    ShareCouponAd,
    PictureAd,

    SwiperPagination,
  },
})
export default class CouponAd extends Vue {
  isEn = language.isEn();
  /** 广告位信息 */
  @Prop() adInfoSet!: AdSet;

  /** 多个swiper时，class会冲突 */
  public swiperClassId = Math.floor(Math.random() * 10000);
  /** 当前active的slide下标 */
  public activeIndex = 0;
  /** swiper对象 */
  private mySwiper: Swiper;

  private get isSingle() {
    return this.adInfoSet.data.length === 1;
  }

  /** 映射相应的组件 */
  public getAdCompName(adInfo: CouponAdConf) {
    switch (adInfo.adType) {
      case AdType.spAd:
      case AdType.otherAd:
        return AdName.PictureAd;
      case AdType.shareCouponAd:
        return AdName.ShareCouponAd;
    }
  }

  /** 获取ad相应的上报扩展字段 */
  public getBiExt(adInfo: CouponAdConf) {
    return {
      fdpId: String(adInfo.dpId), // 广告 id
      fclassid: adInfo.adClassId,
      fadOrder: adInfo.adOrder,
    };
  }

  /** 点击上报 */
  public clickReport(ad: CouponAdConf) {
    biClick('ad.click', this.getBiExt(ad));
  }

  // --------------- 事件start ----------------
  /** swiper item点击 */
  public handleSwiperClick(swiperIndex: number) {
    this.afterClick(swiperIndex);
  }

  /** 单张券点击 */
  public handleSingleClick() {
    this.afterClick(0);
  }
  // --------------- 事件end ----------------

  // --------------- 初始化start --------------
  private initSwiper() {
    if (this.mySwiper) {
      return;
    }
    this.mySwiper = new Swiper(`.swiper-id-${this.swiperClassId}`, {
      loop: true,
      spaceBetween: 10,
      centeredSlides: true,
      watchOverflow: true, // 因为仅有1个slide，swiper无效
      autoHeight: true,
      autoWidth: false,
      autoplay: {
        delay: 2500, // 2.5秒切换一次
        disableOnInteraction: false,
        reverseDirection: false,
      },
      speed: 500,
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper
      on: {
        slideChange: () => {
          if (!this.mySwiper) return;
          this.activeIndex = this.mySwiper.realIndex;
        },
        click: () => {
          if (!this.mySwiper) return;
          const swiperIndex = this.mySwiper.realIndex;
          this.handleSwiperClick(swiperIndex);
        },
      },
    });
  }

  private mounted() {
    if (!this.isSingle) {
      // 只有在多个slide时，才会初始化swiper对象
      this.initSwiper();
    }
  }
  // --------------- 初始化end ----------------
  // --------------- 辅助方法start ----------------
  /** 统一的点击行为 */
  private afterClick(setIndex: number) {
    const ad = this.adInfoSet.data[setIndex];

    // 点击上报
    this.clickReport(ad);

    switch (ad.adType) {
      case AdType.shareCouponAd:
        this.clickItemShareCouponAd(ad);
        break;
      case AdType.otherAd:
        this.clickItemOtherAd(ad);
        break;
      case AdType.spAd:
        this.clickItemSpAd(ad);
        break;
    }
  }
  /** 点击分享券 */
  private clickItemShareCouponAd(ad: CouponAdConf) {
    // 拉起好友助力弹窗
    this.$emit('showHelpFriendDialog', ad.adCouponId);
  }
  /** 点击自定义广告券 */
  private clickItemOtherAd(ad: CouponAdConf) {
    // 自定义广告类型 进行跳转
    windowHelper.redirect(ad.adJumpUrl, 300);
  }
  /** 点击商户广告券 */
  private async clickItemSpAd(ad: CouponAdConf) {
    if (!ad.adSpId) return;
    // 抢券有So商户展示券广告类型
    const [err, merchantInfo] = await to(getMerchantInfo(ad.adSpId));
    if (err) {
      new CustomException(err, 'wecouponOpenAdErr', 'wecoupon打开商户广告位失败');
      return;
    }
    if (merchantInfo) {
      // 拉取商户券半弹窗
      this.$emit('showMerchantDialog', { ...merchantInfo, isFromAd: true, dpId: ad.dpId });
    }
  }
  // --------------- 辅助方法end ----------------
}
